class MonogramTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;
    if (!this.form) return;

    this.handleClick = (e) => {
      // Get selected variant from the clicked element or form
      const formData = new FormData(this.form);
      const selectedVariant = formData.get("id");

      // If no current-variant-id attribute AND no variant selected, show "Select a Size"
      if (!this.currentVariantId && !selectedVariant && "requireSelect" in this.dataset) {
        this.innerHTML = this.dataset.requireSelect;
        return;
      }

      // Use current-variant-id if exists, otherwise form selection
      const variantId = this.currentVariantId || selectedVariant;

      const html = `<monogram-config product-id="${this.productId}" current-variant-id="${variantId}"></monogram-config>`;

      this.button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "monogram-modal" },
        })
      );
    };

    this.button.addEventListener("click", this.handleClick);
  }

  connectedCallback() {}

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.handleClick);
  }

  get productId() {
    return this.getAttribute("product-id");
  }

  get currentVariantId() {
    return this.getAttribute("current-variant-id");
  }
}

if (!customElements.get("monogram-trigger")) {
  customElements.define("monogram-trigger", MonogramTrigger);
}
